import * as React from 'react';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'whatwg-fetch';
import StartPage from "./components/StartPage/StartPage";
import { unregister } from './registerServiceWorker';
require('es6-promise').polyfill();

unregister();

ReactDOM.render(<BrowserRouter>
    <StartPage apiUrl={window.location.origin + "/api/"}></StartPage>
</BrowserRouter>, document.getElementById("root"));
